module.exports = __webpack_public_path__ + "img/hg_05.45c0f3b3.png";